<template>
  <!-- <div class="box" :style="{ height: bgHeight }" v-if="show"> -->
  <div class="wrapper" :style="{ height: bgHeight }" v-if="show">
    <div class="content-box">
      <div class="item-box">
        <van-field
          :left-icon="phone"
          v-model="from.phone"
          type="digit"
          maxlength="11"
          placeholder="请输入注册商户手机号"
        />
      </div>
      <div class="item-box code">
        <van-field :left-icon="code" v-model.trim="from.code" maxlength="4" placeholder="请输入验证码">
          <template #button>
            <van-button
              @click="getVerifyCode"
              class="code-btn"
              size="small"
              :loading="loadingCode"
              loading-type="spinner"
              type="info"
              >{{ codeBtnText }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="submit-btn" @click="submit">
        <van-loading v-if="loadingBtn" type="spinner" size="20px" class="btn-loading">提交绑定</van-loading>
        <span v-else>提交绑定</span>
      </div>
    </div>
  </div>
</template>

<script>
import { bindSms, isBind, bind } from "@/api/bind";
import { Toast } from "vant";
export default {
  data() {
    return {
      from: {
        phone: "",
        code: "",
        openId: this.$route.query.openId ? this.$route.query.openId : "",
      },
      // oTUXS5nHydfHndbcqbtmsREqp3E0
      phone: require("../../assets/bind/phone.png"),
      code: require("../../assets/bind/code.png"),
      loadingCode: false,
      codeBtnText: "获取验证码",
      loadingBtn: false,
      codeBtnDisable: true,
      show: false,
      bgHeight: "",
    };
  },
  created() {
    this.bgHeight = document.body.scrollHeight + "px";
    this.checkBind();
  },
  mounted() {},
  methods: {
    checkBind() {
      isBind({ openId: this.from.openId }).then((res) => {
        if (res.bindStatus === 0) {
          this.show = true;
        } else {
          this.$router.replace({
            path: "/unbind",
            query: {
              openId: this.$route.query.openId,
            },
          });
        }
      });
    },
    getVerifyCode() {
      if (this.loadingCode) {
        return;
      }
      if (!this.codeBtnDisable) {
        return;
      }
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

      if (!this.from.phone) {
        Toast({
          message: "手机号码不能为空",
          icon: "cross",
        });
        return false;
      }
      if (!strTemp.test(this.from.phone)) {
        Toast({
          message: "手机号码格式不正确",
          icon: "cross",
          duration: 2 * 1000,
        });
        return false;
      }
      let params = {
        phone: this.from.phone,
      };
      this.sendRequestCode(params);
    },
    // 获取验证码接口
    sendRequestCode(data) {
      this.loadingCode = true;
      bindSms(data)
        .then((res) => {
          this.loadingCode = false;
          Toast({
            message: "发送成功，请注意查收！",
            icon: "success",
          });
          //   this.isCaptcha = res;
          let time = 60,
            i = 0;
          this.codeBtnText = --time + "s";
          let timer = setInterval(() => {
            this.codeBtnText = --time + "s";
            i++;
            if (i == 1) {
              this.codeBtnDisable = false;
            }
          }, 1000);
          setTimeout(() => {
            this.codeBtnText = "获取验证码";
            this.codeBtnDisable = true;
            clearInterval(timer);
          }, time * 1000);
        })
        .catch((err) => {
          this.loadingCode = false;
          Toast({
            message: err.message,
            icon: "cross",
          });
        });
    },

    //提交绑定
    submit() {
      if (this.from.phone == "") {
        Toast({
          message: "请输入商户手机号",
          icon: "cross",
        });
        return false;
      }
      if (this.from.code == "") {
        Toast({
          message: "请输入验证码",
          icon: "cross",
        });
        return false;
      }
      this.loadingBtn = true;
      bind(this.from)
        .then((res) => {
          this.loadingBtn = false;
          Toast({
            message: "恭喜你，绑定成功！",
            duration: 2 * 1000,
            icon: "success",
          });
          setTimeout(() => {
            this.$router.push({
              path: "/unbind",
              query: {
                openId: this.$route.query.openId,
              },
            });
          }, 2000);

          console.log(res);
        })
        .catch((err) => {
          this.loadingBtn = false;
          Toast({
            message: err.message,
            icon: "cross",
          });
        });
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .van-button--info {
  background: #ffffff;
  border: none;
  color: #865d14;
  border-radius: 10px;
  padding: 10px 16px;
}
/deep/ .van-field__label {
  width: 100px;
}

/deep/ .van-field__left-icon .van-icon {
  font-size: 48px;
}
/deep/ .van-field__left-icon {
  margin-right: 20px;
}

/deep/ .van-field__control {
  color: #333333;
  font-size: 34px;
}
/deep/ .van-field__left-icon::after {
  content: "";
  width: 1px;
  height: 43px;
  position: absolute;
  top: 38px;
  left: 54px;
  background: #e5e6eb;
}
.wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../assets/bind/bg.png") center center no-repeat;
  background-size: 100% 100%;
  background-color: #f5f5f7;
}

.content-box {
  position: absolute;
  width: 668px;
  top: 416px;
  left: 50%;
  background: #ffffff;
  transform: translateX(-50%);
  border-radius: 30px;
  padding: 70px 34px;
  box-sizing: border-box;
  .item-box {
    border-radius: 16px;
    background: #f5f5f7;
    opacity: 1;
    padding: 0px 20px;
    /deep/.van-cell {
      padding: 28px 0px;
      display: flex;
      align-items: center;
      background: #f5f5f7;
    }
    &.code {
      /deep/.van-cell {
        padding: 20px 0px;
        display: flex;
        align-items: center;
        background: #f5f5f7;
      }
    }

    .label {
      font-size: 30px;
      color: #333;
      font-weight: bold;
    }
    .codeNum {
      font-size: 32px;
      font-weight: bold;
    }
    .divider-style {
      margin: 0;
    }
    .code-btn {
      font-size: 26px;
      color: #865d14;
      .van-loading__text {
        color: #865d14;
        font-size: 26px;
      }
    }
  }
  .code {
    margin-top: 50px;
  }
}
.submit-btn {
  width: 600px;
  height: 92px;
  line-height: 92px;
  text-align: center;
  background: linear-gradient(90deg, #f8d69b 1%, #ffe2b6 100%);
  border-radius: 16px;
  z-index: 5;
  color: #865d14;
  font-size: 32px;
  font-weight: 400;
  margin-top: 74px;
}
</style>
